export enum EmojiMood {
  Bad = "Špatně",
  Good = "Dobře",
  Excellent = "Skvěle",
}
